const $body = $('body');
const sBlock = '.multiple-file-upload';
const cBlockLoaded = 'multiple-file-upload_loaded';

$(sBlock).prop.arFiles = [];

// Загрузка файла(ов)
$body.on('change', '.multiple-file-upload__input', function () {
    const $input = $(this);
    const $block = $input.closest(sBlock);
    const $labelList = $block.find('.multiple-file-upload__items');
    const $uploadBtnBlock = $block.find('.multiple-file-upload__btn-block');
    const files = $input[0].files;

    if (typeof files !== 'undefined' && files.length) {
        for (let i = 0; i < files.length; i++) {
            const ext = files[i].name.split('.').pop().toLowerCase();

            if (Array.isArray($block.prop.arFiles) && $block.prop.arFiles.length >= 10) {
                $.fancybox.open('<div><p>Максимальное количество файлов - 10 шт.</p></div>');
                $uploadBtnBlock.hide();
                break;
            } else if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') {
                $.fancybox.open(`
                    <div>
                        <p>Файл "${files[i].name}" не загружен</p>
                        <p>Файл должен быть с расширением JPG/PNG</p>
                    </div>
                `);
            } else if (files[i].size > (1024 * 1024 * 10)) {
                $.fancybox.open(`
                    <div>
                        <p>Файл "${files[i].name}" не загружен</p>
                        <p>Превышено ограничение. Максимальный размер одного файла - 10 мб</p>
                    </div>
                `);
            } else {
                const reader = new FileReader();

                reader.onload = function (e) { // Нет ошибок в чтении файла
                    $labelList.append(
                        `<label class="multiple-file-upload__item" style="background-image:url('${e.target.result}')">
                            <span class="multiple-file-upload__item-close"></span>
                        </label>`,
                    );

                    $block.addClass(cBlockLoaded);

                    if ($labelList.find('.multiple-file-upload__item').length >= 10) {
                        $uploadBtnBlock.hide();
                    }
                };

                reader.readAsDataURL(files[i]);
                $block.prop.arFiles.push(files[i]);
            }
        }

        $input.val('');
        $block.prop('multiple-file-upload', { 'files': $block.prop.arFiles, 'name': $input.attr('name') });
    }
});

// Клик на удаление файла из списка загрузки
$body.on('click', '.multiple-file-upload .multiple-file-upload__item-close', function () {
    const $this = $(this);
    const $block = $this.closest(sBlock);

    $block.find('.multiple-file-upload__btn-block').show();

    if ($block.find('label.multiple-file-upload__item').length === 1) { // Если удаляется последний файл
        $block.removeClass(cBlockLoaded);
    }

    $block.prop.arFiles.splice($this.closest('.multiple-file-upload__item').index(), 1);
    $this.closest('.multiple-file-upload__item').remove();
});